export default __webpack_public_path__ + "static/img_contact_us-0c961e45ed63ddf8430fabcb9c09c309.png";